import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgCommonModule } from '../ng-common.module';

@Component({
  selector: 'pt-page-footer',
  templateUrl: './page-footer.component.html',
  styleUrls: ['./page-footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgCommonModule],
})
export class PageFooterComponent {
  @Input() padding = true;
}
